<template>

<hit_login>
	<div class="hit-row">
		<div class="hit-col-md-6 hit-col-md-hit-offset-3">

			<div class="hit-panel hit-panel-primary hit-html-html">
				<div class="hit-panel-heading">
					{{ $t('message.logout') }}
				</div>

				<div class="hit-panel-body">
					<div class="hit-form-group">
						<a class="hit-btn hit-btn-default hit-btn-block" href="#" v-on:click.prevent="set_logout">{{ $t('message.confirm', {name: $t('message.logout')}) }}</a>
					</div>

				</div>

				<div class="hit-panel-footer">
						<router-link class=" hit-html-a" :to="{ name: 'app', params: {lang: $store.getters.lang} }">{{ $t('message.goTo', {name: $t('message.dashboard')}) }}</router-link>
				</div>
			</div>

		</div>
	</div>
</hit_login>

</template>

<script>

export default{
  name: 'logout',
  data () {
    return {

    }
  },

  methods: {

    set_logout: function () { this.$store.commit('set_user', false) }

  },
  metaInfo: function () {
	    return {
	     title: this.$t('message.logout')
	   }
	 }

}
</script>
